import { render } from "./DriveUIWrapper.vue?vue&type=template&id=0afd2e9f&scoped=true&ts=true"
import script from "./DriveUIWrapper.vue?vue&type=script&lang=ts"
export * from "./DriveUIWrapper.vue?vue&type=script&lang=ts"

import "./DriveUIWrapper.vue?vue&type=style&index=0&id=0afd2e9f&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afd2e9f"]])

export default __exports__